import axios from 'axios';

const getBaseUrl = () => {
  let url = process.env.REACT_APP_API_URL || 'https://api.sharkfragrance.com';
  if (url.endsWith('/')) {
    url = url.slice(0, -1);
  }
  return url;
};

export const API_URL = getBaseUrl();

export const api = axios.create({
  baseURL: API_URL,
});

// Helper for simulating delay if needed
export const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
